import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MarkdownKatexComponent } from './markdown-katex.component';
import { MarkdownKatexService } from './markdown-katex.service';

@NgModule({
  providers: [MarkdownKatexService],
  imports: [CommonModule, TranslateModule, MarkdownKatexComponent],
  exports: [MarkdownKatexComponent],
})
export class MarkdownKatexModule {}
